var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","stroke":"currentColor","aria-hidden":"true","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-width":"3","d":"M12 22.476V1.523M18.548 8.071 12 1.523M5.452 8.071 12 1.523"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }